import { render, staticRenderFns } from "./DocumentsForm.vue?vue&type=template&id=63ab73ae&scoped=true&lang=pug"
import script from "./DocumentsForm.vue?vue&type=script&lang=js"
export * from "./DocumentsForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsForm.vue?vue&type=style&index=0&id=63ab73ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab73ae",
  null
  
)

export default component.exports